"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivitySubTypes = {
    outBoundCall: 1,
    inBoundCall: 2
};
